<template>
  <div class="header">
    <div class="header__box">
      <div v-if="!isAuth" class="header__logo-only">
        <router-link :to="{ name: 'Login' }" class="header__link">
          <img src="@/assets/logo.svg" class="header__logo-img" />
          <span>Karma</span>
        </router-link>
      </div>
      <div v-else class="header__auth" @click="hideMobileMenu">
        <router-link :to="{ name: 'Feed' }" class="header__link">
          <img :src="logoWS" class="header__logo-img" />
          <span>{{ currentWs.name }}</span>
        </router-link>
        <HeaderNav v-if="!screenWidth.isMobile" />
        <div v-if="screenWidth.isMobile" class="actions">
          <RemoveDemo />
          <button
            class="header__menu-mobile"
            :class="{ 'header__menu-mobile_open': mobileMenuVisible }"
            @click.stop="toggleMobileMenu"
          />
        </div>
      </div>
    </div>
  </div>
  <HeaderNav v-if="screenWidth.isMobile && mobileMenuVisible" @click="hideMobileMenu" @hideMenuIfMobile="hideMobileMenu" />
  <k-active-color />
</template>

<script setup>
import { reactive, ref, onMounted, onUnmounted, computed, watch, provide } from 'vue';
import HeaderNav from './HeaderNav.vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import logoIcon from '@/assets/logo.svg';
import { BREAKPOINTS } from '@/utils/constants';
import RemoveDemo from '@/components/PageHeader/RemoveDemo.vue';

const store = useStore();
const router = useRouter();

const isAuth = computed(() => {
  return (
    !['Invitation', 'CreateProfile', 'AddPhoto', 'Welcome', 'CreateTeam', 'GoodBye'].includes(router.currentRoute.value.name) &&
    store.state.auth.isLoggedIn
  );
});

const currentWs = computed(() => {
  return store.state.auth.currentWorkspace;
});

const logoWS = computed(() => {
  return store.state.auth.currentWorkspace.logo.url || logoIcon;
});

const mobileMenuVisible = ref(false);

const toggleMobileMenu = () => {
  mobileMenuVisible.value = !mobileMenuVisible.value;
};

const screenWidth = reactive({
  isMobile: window.innerWidth <= BREAKPOINTS.SM,
});

provide('workspace', currentWs);

watch(
  () => store.state.auth.currentWorkspace,
  (newValue) => (currentWs.value = newValue),
);

const handleResize = () => {
  screenWidth.isMobile = window.innerWidth <= BREAKPOINTS.SM;
};

onMounted(() => {
  window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});

const hideMobileMenu = () => {
  mobileMenuVisible.value = false;
};
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  background: $white-color;
  box-shadow:
    0px 8px 60px 0px rgba(35, 75, 111, 0.04),
    0px 8px 40px 0px rgba(75, 111, 143, 0.15),
    0px 6px 10px 0px rgba(117, 145, 171, 0.02);
  padding: 7px 15px;

  @include sm {
    position: relative;
    z-index: 1;
  }

  &__box {
    max-width: 1140px;
    margin: 0 auto;
    min-height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__logo-only {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 36px;
    gap: 4px;
    font-weight: 600;
  }

  &__logo-img {
    object-fit: contain;
    width: 22px;
    height: 22px;
    border-radius: 8px;
  }

  &__link {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
    color: #263856;
    font-size: 16.311px;
    font-weight: 600;
    line-height: 8.155px;
    text-decoration: none;
  }

  &__auth {
    display: flex;
    justify-content: start;
    width: 100%;

    @include sm {
      justify-content: space-between;
    }

    .actions {
      display: flex;
      align-items: center;
      gap: 20px;
    }
  }

  &__menu-mobile {
    background-color: transparent;
    background-image: url('./menu-mobile.svg');
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
    cursor: pointer;

    &_open {
      background-image: url('./menu-mobile-close.svg');
    }
  }
}
</style>
